import { useEffect, useRef } from 'react';
export const useMountEffect = (onMount, onUnmount)=>{
    const mountRef = useRef(onMount);
    const unmountRef = useRef(onUnmount);
    mountRef.current = onMount;
    unmountRef.current = onUnmount;
    useEffect(()=>{
        mountRef.current?.();
        return ()=>{
            unmountRef.current?.();
        };
    }, []);
};
